module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--7--a-aafbba1f.png";